module.exports = __webpack_public_path__ + "static/media/whyus7.715ff0f8.png";